export default __webpack_public_path__ + "static/wooden-stairs-and-fence-2e8b1bba2c59eaa8f90aa34ec1a74443.jpg";